if (!customElements.get('notify-me')) {
  class NotifyMe extends HTMLElement {
    constructor() {
      super()
  
      this.form = this.querySelector('[data-notifyme-form]');
      this.formFeedbackMessage = this.form.querySelector('[data-message-global]');
      this.form.addEventListener('submit', this.submitForm.bind(this));
    }
  
    submitForm(event) {
      event.preventDefault()

      const openedModal = document.querySelector('modal-dialog.is-open');
      const newsletterOptin = openedModal ? openedModal.querySelector('[data-newsletter-optin]') : null;
      const wantsNewsletter = newsletterOptin && newsletterOptin.checked;

      if (newsletterOptin && !wantsNewsletter) {
        this.formFeedbackMessage.innerText = this.dataset.newsletterRequired ||
          'Debes aceptar la suscripción a la newsletter para continuar.';
        return;
      }

      let email = this.querySelector('#emailBackInStock').value
      let platformFeed = this.dataset.klaviyoFeed
      let variantId = this.querySelector('[data-variant-id]').value;
      let variantDataId = platformFeed + variantId;

      console.log('Newsletter optin checked:', wantsNewsletter);

      if (wantsNewsletter) {
        console.log('Calling klaviyoNewsletterSubscribe...');
        const restockValue = this.form.querySelector('[name="properties[RESTOCK]"]')?.value || '';
        console.log('---- restockValue at submit:', restockValue);
        this.klaviyoNewsletterSubscribe(email, restockValue);
      }
      
      this.klaviyoBackInStockSubscribe(email, variantDataId)
        .then((response) => {
          if (response.status == 'ok') {
            const openedModal = document.querySelector('modal-dialog.is-open');
            if (openedModal) {
              openedModal.querySelector('[data-notify-content]').classList.add('hidden')
              openedModal.querySelector('[data-notify-success]').classList.add('active')
              openedModal.querySelector('[data-notify-cancel]').classList.remove('hidden')
              openedModal.querySelector('[data-notify-submit]').classList.add('hidden')
            } else {
              console.error('No openned notifyme modal found');
            }
          } else {
            console.error(response);
            this.formFeedbackMessage.innerText = this.dataset.subscribeError
          }
        })
    }
  
    async klaviyoBackInStockSubscribe(email, variantDataId) {
      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoId}`;
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": variantDataId
              }
            }
          }
        }
      }

      console.log('---- payload', payload);
  
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: this.dataset.klaviyoApiRevision,
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
  
      const response = fetch(url, options)
        .then(async result => {
          if (result.ok == false) {
            const resultJson = await result.json();
            console.error(resultJson);
            return {
              status: 'error',
              error: response.ok
            }
          }
          
          return {
            status: 'ok'
          }
        })
        .catch(error => {
          console.error(error)
          return {
            status: 'error',
            error: response.ok
          }
        })
        
      return response
    }

    async klaviyoNewsletterSubscribe(email, restockValue = '') {
      const lang = document.documentElement.lang || 'en';
      const languageCode = lang.startsWith('es') ? 'es' : (lang.startsWith('de') ? 'de' : 'en');
      const shopifyMarket = document.documentElement.dataset.market || languageCode;

      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.dataset.klaviyoId}`;
      
      const payload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "custom_source": "notify-me-modal",
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                  "properties": {
                    "Language code": languageCode,
                    "Market": shopifyMarket,
                    "RESTOCK": restockValue
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": "VCMida"
              }
            }
          }
        }
      };

      console.log('---- newsletter payload', JSON.stringify(payload));

      try {
        const result = await fetch(url, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: this.dataset.klaviyoApiRevision,
            'content-type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        console.log('Newsletter response status:', result.status);
        const text = await result.text();
        console.log('Newsletter response body:', text);

        // Llamada adicional para persistir properties custom en el perfil
        await this.klaviyoUpdateProfile(email, restockValue);

      } catch (error) {
        console.error('Newsletter optin error:', error);
      }
    }

    async klaviyoUpdateProfile(email, restockValue) {
      const url = `https://a.klaviyo.com/client/profiles/?company_id=${this.dataset.klaviyoId}`;

      const payload = {
        "data": {
          "type": "profile",
          "attributes": {
            "email": email,
            "properties": {
              "RESTOCK": restockValue
            }
          }
        }
      };

      console.log('---- profile update payload', JSON.stringify(payload));

      try {
        const result = await fetch(url, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: this.dataset.klaviyoApiRevision,
            'content-type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        console.log('Profile update response status:', result.status);
        const text = await result.text();
        console.log('Profile update response body:', text);
      } catch (error) {
        console.error('Profile update error:', error);
      }
    }
  }

  customElements.define('notify-me', NotifyMe);
}
